import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PrescriptionModal } from '../components/PrescriptionModal';
import { Link } from 'react-router-dom';
export function Prescriptions() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'refill' | 'transfer'>('refill');
  const openModal = (type: 'refill' | 'transfer') => {
    setModalType(type);
    setModalOpen(true);
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white pb-20" data-id="element-532">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20 mb-12 md:mb-16" data-id="element-533">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8" data-id="element-534">
          Prescription Services
        </h1>
        <p className="text-lg text-slate-600 mb-12 max-w-3xl" data-id="element-535">
          Manage your health with our comprehensive prescription services. We
          offer easy refills, transfers, and professional consultations.
        </p>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-536">
          <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-537">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-538">
              Refill a Prescription
            </h2>
            <p className="text-slate-600 mb-6" data-id="element-539">
              Quickly refill your existing prescriptions online for pickup at
              either of our locations.
            </p>
            <button onClick={() => openModal('refill')} className="bg-clinical-blue text-white font-bold py-3 px-6 rounded-xl hover:bg-blue-700 transition-all" data-id="element-540">
              Start Refill
            </button>
          </div>
          <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-541">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-542">
              Transfer to Us
            </h2>
            <p className="text-slate-600 mb-6" data-id="element-543">
              Switching to Daily Care Pharmacy is simple. Provide your details
              and we'll handle the rest.
            </p>
            <Link to="/transfer-prescription" className="inline-block border-2 border-clinical-blue text-clinical-blue font-bold py-3 px-6 rounded-xl hover:bg-clinical-blue hover:text-white transition-all text-center" data-id="element-544">
              Transfer Now
            </Link>
          </div>
        </div>
      </div>
      <PrescriptionModal isOpen={modalOpen} onClose={() => setModalOpen(false)} type={modalType} data-id="element-545" />
    </motion.div>;
}